import { createAsyncThunk } from '@reduxjs/toolkit';
import { machineService } from 'services';
import { newItemEquipment } from 'types';

export const endLease = createAsyncThunk<any, newItemEquipment>('machineDetail/endLease', async (params) => {
  const machineItem = params.machine
    ? params.machine.map((item) => {
        if (!item.i_id) {
          return {
            operation: 1,
            link_to_parent: true,
            i_id: item.i_id,
            action_id: 'Return_the_machine',
            item: {
              i_id: item.i_id,
              d_id: item.d_id,
              machine_type: item.machine_type,
              machine_serial_number: item.machine_serial_number,
              lease_contract_id: params.item.lease_contract_id,
            },
            is_force_update: true,
          };
        }
        return {
          operation: 2,
          link_to_parent: true,
          i_id: item.i_id,
          action_id: 'Return_the_machine',
          item: {
            i_id: item.i_id,
            d_id: item.d_id,
            machine_type: item.machine_type,
            machine_serial_number: item.machine_serial_number,
            lease_contract_id: params.item.lease_contract_id,
          },
          is_force_update: true,
        };
      })
    : [];
  const newParams = { ...params, related_ds_items: machineItem };
  const response = await machineService.endLease(newParams);
  return response;
});
